import { qltClient } from '../clients';
import { Repository } from '../core/repository';
import type { Id, QltClassNoteLesson } from '../types';

export const ClassNoteLessonRepository = {
  ...Repository<QltClassNoteLesson>(qltClient, '/class-note-lesson'),
  getLessonByClassNote: (classNote: Id) =>
    qltClient
      .get('/getLessonByClassNote', { params: { classNote } })
      .then((res) => res.data as QltClassNoteLesson | null),
};

export default ClassNoteLessonRepository;
